import _ from 'lodash';

import {
  sanitizeAndTransformResponse,
  sanitizeAndTransformResponseData,
} from 'ev-api/common/transformers';

import {
  GetCustomFormSubmissions,
  GetCustomFormSubmissionsResponse,
  GetSubmission,
  GetSubmissionResponse,
  SubmissionAccess,
  SubmissionResponse,
} from './responses';

export const transformSubmissionsResponse = (
  response: GetCustomFormSubmissionsResponse,
): GetCustomFormSubmissions => {
  const clonedResponseData = _.cloneDeep(response);
  clonedResponseData.data.map((submission: SubmissionResponse) => {
    _.set(
      submission,
      'shared',
      submission.access === SubmissionAccess.ProviderShared,
    );
    return submission;
  });
  return sanitizeAndTransformResponseData(clonedResponseData);
};

export const transformSubmissionResponse = (
  response: GetSubmissionResponse,
): GetSubmission => {
  const clonedResponseData = _.cloneDeep(response.data);
  _.set(
    clonedResponseData,
    'shared',
    clonedResponseData.access === SubmissionAccess.ProviderShared,
  );
  return sanitizeAndTransformResponse(response);
};
